/* eslint-disable quotes */
import React from "react";
import ReactRouterPropTypes from "react-router-prop-types";
import { FormattedMessage } from "react-intl";

import { Pluggable } from "@folio/stripes/core";

const PrintBarcodesRoute = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      // redirectTo="print-barcodes"
    >
      <FormattedMessage
        id="ui-inventory.templatesPluginNotAvailable"
        defaultMessage="Templates plugin not available"
      />
    </Pluggable>
  );
};

PrintBarcodesRoute.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default PrintBarcodesRoute;
